import React from "react";

import { css, useTheme } from "@emotion/react";

import { MarkdownInline } from "../../../Markdown";

const HeadlineItem = ({
    headline = 1,
    fontSize = "2rem",
    color = "red",
    hasTextOutline = false,
    wordBreak = false,
    fSExtraSmall = fontSize,
    fSSmall = fontSize,
    fSMedium = fontSize,
    fSNormal = fontSize,
    fSLarge = fontSize,
    fSExtraLarge = fontSize,
    children,
    ...props
}) => {
    const Line = `h${headline}`;
    const theme = useTheme();
    const colorCode = theme.colors[color]
        ? theme.colors[color].toString()
        : theme.colors.red.toString();

    const style = css`
        &,
        .content & {
            ${wordBreak && "word-break: break-all;"}
            ${hasTextOutline &&
            `text-shadow:
                -1px -1px 0 ${theme.colors.white.toString()},
                1px -1px 0 ${theme.colors.white.toString()},
                -1px 1px 0 ${theme.colors.white.toString()},
                1px 1px 0 ${theme.colors.white.toString()};
            `}

            font-weight: 900;
            color: ${colorCode};
            margin: 20px 0;
            ${theme.breakpoints.upTo.medium.css`
           font-size: 1.7rem;
        `}
            ${theme.breakpoints.propPerEachFrom("font-size", {
                extraLarge: fSExtraLarge,
                large: fSLarge,
                normal: fSNormal,
                medium: fSMedium,
                small: fSSmall,
                extraSmall: fSExtraSmall,
            })}
        }
    `;

    return (
        <Line {...props} css={style}>
            {typeof children === "string" ? (
                <MarkdownInline {...{ children }} />
            ) : (
                children
            )}
        </Line>
    );
};

export default HeadlineItem;
